import { render, staticRenderFns } from "./ComThree.vue?vue&type=template&id=86cc127c&scoped=true&"
import script from "./ComThree.vue?vue&type=script&lang=js&"
export * from "./ComThree.vue?vue&type=script&lang=js&"
import style0 from "./ComThree.vue?vue&type=style&index=0&id=86cc127c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cc127c",
  null
  
)

export default component.exports